export { default } from './PageInfoCategories.vue'
